import { isEmpty } from 'lodash';
import checkIsVariantEnabled from './checkIsVariantEnabled';
import checkIsVariantForPrice from './checkIsVariantForPrice';
import { formatPriceInput } from '../services/formatPrice';

// get the variant values from the form
// delete any variant values that are not visible
// gets the optionId for the first selected option
export default function getFormVariantValues(variants, formVariants, currency, selectedPriceId) {
  if (isEmpty(formVariants) || !variants || !Array.isArray(variants)) return {};

  const formVariantValues = Object.entries(formVariants).reduce(
    (obj, [variantId, selectedOptions]) => {
      const variant = variants.find(variant => variant._id === variantId);

      if (!variant) return obj;

      if (!checkIsVariantForPrice(variant, selectedPriceId)) return obj;

      // we need to unset any that is not visible
      const visible = checkIsVariantEnabled(variant, formVariants, variants);

      if (!visible) {
        delete obj[variantId];
      } else {
        if (variant.selectionType === 'quantity' || variant.selectionType === 'multiple') {
          const selectedOptionsWithQuantity = selectedOptions
            .filter(option => option.quantity > 0)
            .map(o => {
              return {
                ...o,
                payWhatYouWantAmount: formatPriceInput(o.payWhatYouWantAmount, currency),
              };
            });

          obj[variantId] = selectedOptionsWithQuantity;
        } else {
          const selectedOption = selectedOptions.find(o => o.quantity > 0);

          if (selectedOption?.payWhatYouWantAmount != null) {
            obj[variantId] = {
              optionId: selectedOption.optionId,
              payWhatYouWantAmount: formatPriceInput(selectedOption.payWhatYouWantAmount, currency),
            };
          } else {
            obj[variantId] = selectedOption?.optionId || null;
          }
        }
      }

      return obj;
    },
    {},
  );

  return formVariantValues;
}
